module.exports = __webpack_public_path__ + "static/media/south-africa.8f3d36c9.svg";